import React from 'react';
import { Navigate } from 'react-router-dom';
import { useBusinessAuth } from '../contexts/BusinessAuthContext';

const ProtectedBusinessRoute = ({ children }) => {
  const { isBusinessAuthenticated, businessLoading } = useBusinessAuth();

  // Show loading while checking authentication
  if (businessLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to business login if not authenticated
  if (!isBusinessAuthenticated) {
    return <Navigate to="/business-login" replace />;
  }

  // Render protected content
  return children;
};

export default ProtectedBusinessRoute;
